import { useQuery } from '@tanstack/react-query';
import { useMsal, useAccount } from '@azure/msal-react';
import { CacheLookupPolicy } from '@azure/msal-browser';
import { loginRequest } from '../auth/authConfig';

/**
 * Загружает фото пользователя из MS Graph по userId.
 * Использует скоуп User.ReadBasic.All.
 * Кэшируется на 30 минут — фото меняются редко.
 */
export function useUserPhoto(userId: string | undefined) {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  return useQuery({
    queryKey: ['userPhoto', userId, account],
    queryFn: async (): Promise<string | null> => {
      if (!userId || !account) return null;

      const tokenResponse = await instance.acquireTokenSilent({
        ...loginRequest,
        account,
        cacheLookupPolicy: CacheLookupPolicy.AccessTokenAndRefreshToken,
      });

      const response = await fetch(
        `https://graph.microsoft.com/v1.0/users/${userId}/photo/$value`,
        { headers: { Authorization: `Bearer ${tokenResponse.accessToken}` } },
      );

      if (!response.ok) return null;

      const blob = await response.blob();
      return URL.createObjectURL(blob);
    },
    enabled: !!userId && !!account,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: false,
  });
}
